import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import useSeo from "../../hooks/useSeo";
import { shopGet } from "../../api/shopApi";
import ShopProductCard from "./ShopProductCard";

export default function ShopCategoryPage() {
  const { slug } = useParams();
  const [cat, setCat] = useState(null);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const pageSize = 12;

  useSeo({
    title: cat ? `${cat.name} - 生活好物商城` : "商品分类 - 生活好物商城",
    metaDescription: cat?.description || "浏览分类下的日常好物。",
    path: `/shop/category/${slug}`,
  });

  useEffect(() => {
    setPage(1);
  }, [slug]);

  useEffect(() => {
    if (!slug) return;
    setLoading(true);
    setError("");
    Promise.all([
      shopGet(`/categories/${slug}`),
      shopGet(`/products?category=${encodeURIComponent(slug)}&page=${page}&page_size=${pageSize}`),
    ])
      .then(([c, p]) => {
        setCat(c);
        setItems(p.items || []);
        setTotal(p.total || 0);
      })
      .catch((e) => setError(e.message || "加载失败"))
      .finally(() => setLoading(false));
  }, [slug, page]);

  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-pink-50 to-amber-50 flex flex-col">
      <Header />
      <main className="flex-1 px-4 py-8">
        <div className="max-w-6xl mx-auto space-y-6">
          <Link to="/shop" className="text-sm text-pink-600 hover:underline">
            ← 返回商城首页
          </Link>
          <header className="space-y-2">
            <h1 className="text-3xl font-bold text-gray-800">{cat?.name || "分类"}</h1>
            {cat?.description ? <p className="text-gray-500 text-sm">{cat.description}</p> : null}
          </header>
          {error ? <p className="text-rose-600 text-sm">{error}</p> : null}
          {loading ? (
            <p className="text-center text-gray-400 py-10">加载中…</p>
          ) : items.length === 0 ? (
            <p className="text-center text-gray-400 py-10">该分类暂无在售商品</p>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {items.map((item) => (
                <ShopProductCard key={item.id} item={item} />
              ))}
            </div>
          )}
          {totalPages > 1 ? (
            <div className="flex justify-center gap-3">
              <button
                type="button"
                disabled={page <= 1}
                onClick={() => setPage((p) => p - 1)}
                className="px-4 py-2 border rounded-lg text-sm disabled:opacity-40"
              >
                上一页
              </button>
              <span className="text-sm text-gray-500 self-center">
                {page} / {totalPages}
              </span>
              <button
                type="button"
                disabled={page >= totalPages}
                onClick={() => setPage((p) => p + 1)}
                className="px-4 py-2 border rounded-lg text-sm disabled:opacity-40"
              >
                下一页
              </button>
            </div>
          ) : null}
        </div>
      </main>
      <Footer />
    </div>
  );
}
